/* Centralized SEO injector — every page (platform + tenant stores) consumes the same
   /public/seo/* payloads. Tenant-isolated: payload comes from the store's own config. */

const setMeta = (attr, name, content) => {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function applySeo({ title, description, keywords, canonical, robots, og = {}, twitter = {}, jsonld = [], favicon, gsc_verification } = {}) {
  if (typeof document === "undefined") return;
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "keywords", keywords);
  setMeta("name", "robots", robots);
  if (gsc_verification) setMeta("name", "google-site-verification", gsc_verification);
  for (const [k, v] of Object.entries(og)) setMeta("property", `og:${k}`, v);
  for (const [k, v] of Object.entries(twitter)) setMeta("name", `twitter:${k}`, v);
  setLink("canonical", canonical);
  if (favicon) setLink("icon", favicon);
  document.head.querySelectorAll("script[data-mz-seo]").forEach((n) => n.remove());
  for (const obj of jsonld || []) {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-mz-seo", "1");
    s.textContent = JSON.stringify(obj);
    document.head.appendChild(s);
  }
}

/* Product structured data built from the EXISTING catalog object (no duplicate DB). */
export function productJsonLd(p, storeName, url) {
  const price = p.price != null ? p.price : p.sale_price;
  const ld = {
    "@context": "https://schema.org", "@type": "Product",
    name: p.name, description: (p.description || "").slice(0, 300),
    image: (p.images || []).filter(Boolean), url,
    brand: { "@type": "Brand", name: storeName },
    ...(p.sku ? { sku: p.sku } : {}),
    offers: {
      "@type": "Offer", url, priceCurrency: "INR",
      ...(price != null ? { price } : {}),
      availability: (p.stock === 0 || p.out_of_stock)
        ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
    },
  };
  if (p.rating && p.rating_count) ld.aggregateRating = { "@type": "AggregateRating", ratingValue: p.rating, reviewCount: p.rating_count };
  return ld;
}

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name, item: it.url,
    })),
  };
}
